import React, { useEffect } from "react";
import {
  Navbar,
  Nav,
  OverlayTrigger,
  Tooltip,
  Modal,
  Dropdown,
} from "react-bootstrap";
import {
  BsBoxArrowInRight,
  BsFileArrowDownFill,
  BsFileEarmarkArrowDownFill,
  BsFillRecordCircleFill,
} from "react-icons/bs";
import { AiOutlineAppstoreAdd } from "react-icons/ai";
import { SiConvertio, SiGithubactions, SiDatabricks } from "react-icons/si";
import { TbPrompt, TbAB2 } from "react-icons/tb";
import { useState, useContext } from "react";
import RepoContext from "../context/Repos";
import { convertCode } from "../APIs/githubApi";
import { sendapi } from "../APIs/githubApi";
import { databricksCloudfunc } from "../APIs/openAPI";
import { saveAs } from "file-saver";

import {
  callapi,
  callapiPrompt,
  callapiExplain,
  callconversionLikeliness,
} from "../APIs/openAPI";
import {
  callazureapi,
  callazureapiPrompt,
  callazureapiExplain,
  callazureconversionLikeliness,
} from "../APIs/AzureOpenAi";
import { pushCodeToGithub } from "../APIs/githubApi";
import { githubContents } from "../APIs/githubApi";
import buildTree from "../utils/buildFolderTree";
import { MdSelectAll } from "react-icons/md";
import { css } from "@emotion/react";
import { ScaleLoader } from "react-spinners";
import { Row, Col } from "react-bootstrap";
import { fetchFileContents } from "../APIs/githubApi";
import { GoCodeReview } from "react-icons/go";
import { PiNotebookDuotone } from "react-icons/pi";

export const ActionButtons = () => {
  const {
    InputRepo,
    OutputRepo,
    setOutputRepo,
    InputRepoCreds,
    OutputRepoCreds,
    srcFileTree,
    destFileTree,
    currInputContent,
    currOutputContent,
    setCurrOutputContent,
    setCurrInputContent,
    setDestFileTree,
    multiSelect,
    setMultiSelect,
    selectedFiles,
    setSelectedFiles,
  } = useContext(RepoContext);

  const [isLoading, setIsLoading] = useState(false); // for displaying loading spinner
  const [filesCount, setFilesCount] = useState(0);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showConversionDropdown, setShowConversionDropdown] = useState(false);
  const [selectedConversion, setSelectedConversion] = useState(null);
  const [reviewSelected, setReviewSelected] = useState(null);

  const [conversionColor, setConversionColor] = useState("grey");

  const [codeCells, setCodeCells] = useState([]);

  const handleAddCodeCell = () => {
    alert("Feature Disabled Purposefully - Please contact admin for inclusion");
    return;
    if (currOutputContent.content) {
      // Add a new code cell to the array of code cells
      setCodeCells([...codeCells, currOutputContent.content]);

      // Log the count of code cells
      console.log("Total code cells:", codeCells.length + 1);
      alert("Added this to a new cell successfully");
    } else {
      alert("Convert teradata file first");
    }
  };

  let possibleConversion = [
    "JS to Python",
    "Angular 2 to Angular 12+",
    "C++ to Java",
    "Java to Springboot",
    "Refactor the code",
    "On Prem JS to Python",
    "Teradata to Databricks",
  ];

  const handleConversionDropdownSelect = (eventKey) => {
    // Perform the desired action based on the selected dropdown item
    setSelectedConversion(eventKey);
    console.log("Selected dropdown item:", eventKey);
    // Example:
    // if (eventKey === "option1") {
    //   // Perform action for option1
    // } else if (eventKey === "option2") {
    //   // Perform action for option2
    // }
    // Hide the dropdown after making a selection
    setShowConversionDropdown(false);
  };
  const handleLanguageClick = async () => {
    setShowConversionDropdown(!showConversionDropdown);
  };

  const handleConvertioClick = async () => {
    if (Object.keys(currInputContent).length === 0) {
      alert("Please select a file to convert");
      return;
    }
    if (!selectedConversion) {
      alert("Please select the conversion type first");
      return;
    }

    // THIS WILL EXECUTE WHEN MULTISELECTION IS TURNED ON
    if (multiSelect && selectedFiles.length > 1) {
      let x = selectedFiles.length;
      //[working]alert(filesCount);
      for (let i = 0; i < x; i++) {
        setFilesCount(i + 1);
        setIsLoading(true);
        let fileUrl = selectedFiles[i].url;
        let fileContents = await fetchFileContents(
          InputRepoCreds.patToken,
          fileUrl
        );
        //adding content and ext field to selectedFiles structure
        selectedFiles[i] = {
          ...selectedFiles[i],
          content: fileContents.content,
          ext: fileContents.ext,
        };
        console.log("File after processing = ", selectedFiles[i]);
        await callapi(selectedFiles[i].content, selectedConversion)
          .then((res) => {
            console.log("Converting ", i, " => ", res);
            //adding converted code & converted ext field
            selectedFiles[i] = {
              ...selectedFiles[i],
              convertedContent: res,
              convertedExt: "py",
            };
          })
          .catch((err) => {
            console.log("Converting error ", i, " => ", err);
          });
      }
      setIsLoading(false);
      console.log(
        "SelectedFiles after Multiselect Conversion => ",
        selectedFiles
      );
      return;
    }

    // THIS WILL EXECUTE WHEN A SINGLE FILE IS SELECTED
    setIsLoading(true); // Set loading state to true

    callapi(currInputContent.content, selectedConversion)
      .then((res) => {
        console.log("After Code conversion", res);
    
        let obj = { content: res, ext: "py" };
        setCurrOutputContent({ ...obj });
      })
      .catch((err) => {
        console.log("After code conversion", err);
      })
      .finally(() => {
        setIsLoading(false); // Set loading state to false after API call is complete
      });
  };

  const handlePromptClick = () => {
    // Perform the desired action for Prompt

    if (Object.keys(currOutputContent).length === 0) {
      alert("Please select a file for extra instructions");
    } else {
      const newPrompt = prompt(
        "Enter any extra details: eg. This file should not import js libraries, instead it should import libraries present in python in this code."
      );
      // Check if the user pressed "Cancel" on the prompt
      if (newPrompt !== null) {
        setIsLoading(true); // set loading state to true
        callapiPrompt(currOutputContent.content, newPrompt, selectedConversion)
          .then((res) => {
            console.log("After new prompt", res);
            let obj = { content: res, ext: "py" };
            setCurrOutputContent({ ...obj });
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    }
  };

  // const handleFileDownloadClick = () => {
  //   const pythonCode = currOutputContent.content;
  //   // Create a Jupyter Notebook structure manually
  //   const notebook = {
  //     cells: [
  //       {
  //         cell_type: 'code',
  //         execution_count: null,
  //         metadata: {},
  //         outputs: [],
  //         source: pythonCode, // Your Python code goes here
  //       },
  //     ],
  //     metadata: {
  //       kernelspec: {
  //         display_name: 'Python 3',
  //         language: 'python',
  //         name: 'python3',
  //       },
  //       language_info: {
  //         codemirror_mode: {
  //           name: 'ipython',
  //           version: 3,
  //         },
  //         file_extension: '.py',
  //         mimetype: 'text/x-python',
  //         name: 'python',
  //         nbconvert_exporter: 'python',
  //         pygments_lexer: 'ipython3',
  //         version: '3.8.8', // Change to your Python version
  //       },
  //     },
  //     nbformat: 4,
  //     nbformat_minor: 5,
  //   };

  //   // Convert the Jupyter Notebook structure to JSON format
  //   const notebookJson = JSON.stringify(notebook);

  //   // Create a Blob with the JSON content
  //   const blob = new Blob([notebookJson], { type: 'application/json' });

  //   // Trigger the download using FileSaver.js
  //   saveAs(blob, 'output.ipynb');
  // };
  const handleFileDownloadClick = () => {
    // Create an array of Jupyter code cells
    const notebookCells = codeCells.map((code, index) => ({
      cell_type: "code",
      execution_count: index + 1, // You can customize the execution count as needed
      metadata: {},
      outputs: [],
      source: code,
    }));

    // Create a Jupyter Notebook structure
    const notebook = {
      cells: notebookCells,
      metadata: {
        kernelspec: {
          display_name: "Python 3",
          language: "python",
          name: "python3",
        },
        language_info: {
          codemirror_mode: {
            name: "ipython",
            version: 3,
          },
          file_extension: ".py",
          mimetype: "text/x-python",
          name: "python",
          nbconvert_exporter: "python",
          pygments_lexer: "ipython3",
          version: "3.8.8", // Change to your Python version
        },
      },
      nbformat: 4,
      nbformat_minor: 5,
    };

    // Convert the Jupyter Notebook structure to JSON format
    const notebookJson = JSON.stringify(notebook);

    // Create a Blob with the JSON content
    const blob = new Blob([notebookJson], { type: "application/json" });

    // Trigger the download using FileSaver.js
    saveAs(blob, "output.ipynb");
  };

  const handleDatabricks = async () => {
    alert("Feature Disabled Purposefully - Please contact admin for inclusion");
    return;
    if (Object.keys(currOutputContent).length === 0) {
      alert("Please convert a file/select a file in output panel");
      return;
    }
    const databricksUrl = prompt("Enter Databricks URL : ");
    const code = currOutputContent.content;
    console.log("DB URL = ", databricksUrl, " and Code = ", code);

    if (databricksUrl) {
      //alert("dbricks button clicked with url = ", databricksUrl);
      //await databricksCloudfunc(databricksUrl,code);
      databricksCloudfunc(databricksUrl, code).then((res) => {
        console.log("After pushing to databricks ", res);
      });
    }
  };

  const handleRemoteRepoClick = async () => {
    if (Object.keys(currOutputContent).length === 0) {
      alert("Please convert a file/select a file in output panel");
      return;
    }

    const filePath = prompt("Enter the file path: eg. path/to/your/file.js :");
    const userName = OutputRepoCreds.username;
    const pat = OutputRepoCreds.patToken;
    const repoName = OutputRepoCreds.repoName;
    const code = currOutputContent.content;

    console.log("username", userName, "pat", pat, "repoName", repoName);

    if (filePath) {
      alert("Remote Repo button clicked with file path: " + filePath);
      // Perform the desired action for Remote Repo with the provided file path

      await pushCodeToGithub(userName, pat, repoName, filePath, code);
      //change file structure
      let destinationProject = await githubContents(userName, pat, repoName);
      console.log("changing destination project", destinationProject.data);

      //building new tree
      const destTree = await buildTree(destinationProject.data, pat, "output");
      setDestFileTree([...destTree]);
    } else {
      alert("No file path entered");
    }
  };

  const handleSelectMulti = async () => {
    if (!InputRepo) {
      alert("Please Import a repo first");
      return;
    }
    setMultiSelect(!multiSelect);
    setSelectedFiles(null);
    console.log(multiSelect);
  };

  const handleCodeReview = async () => {
    //alert("Code Review button clicked");
    //If no files are converted, then there shouldn't be any code review
    setShowDropdown(!showDropdown);
    if (selectedFiles != null && !selectedFiles[0]?.convertedContent) {
      alert("No files are converted, first convert them to review");
    }
  };

  const handleExplainClick = async () => {
    //alert ("Handle explain clicked ");
    if (Object.keys(currInputContent).length === 0) {
      alert("Please select at least one file");
    } else if (multiSelect && selectedFiles.length > 1) {
      alert("Please select a single file for explanation");
    } else {
      //alert ("file selected explanation in progress");
      setIsLoading(true);
      let newPrompt =
        "Please explain this file to me, what is it used for?, which language is it written in?, what's the purpose of this file? etc. Explain all such things from the code given here.";
      callapiExplain(currInputContent.content, newPrompt)
        .then((res) => {
          console.log("After explaination ", res);
          let obj = { content: res, ext: "py" };
          setCurrOutputContent({ ...obj });
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const handleConversionLikeliness = async () => {
    if (selectedConversion && currInputContent.content) {
      callconversionLikeliness(currInputContent.content, selectedConversion)
        .then((res) => {
          console.log("After conversion likeliness", res);

          const pattern = /\[(\d+\/\d+)\]/;
          const match = res.match(pattern);
          if (match) {
            const extractedText = match[1];
            console.log("Extracted Text = ", extractedText);
            if (extractedText === "4/5" || extractedText === "5/5") {
              setConversionColor("green");
              //console.log("state changed");
            } else if (extractedText === "3/5") {
              setConversionColor("yellow");
            } else if (extractedText === "2/5") {
              setConversionColor("orange");
            } else if (extractedText === "1/5") {
              setConversionColor("red");
            }
          } else {
            console.log("Pattern not found");
          }
        })
        .finally(() => {
          console.log("color changed");
        });

      //[working]console.log("Selected Conversion = ",selectedConversion, " and code = ",currInputContent.content);
    }
  };
  useEffect(() => {
    setConversionColor("grey");
    console.log("Use effect triggered");
    handleConversionLikeliness();
  }, [currInputContent, selectedConversion]);

  const handleDropdownSelect = (file) => {
    setReviewSelected(file.name);
    console.log("Selected File:", file);
    // Perform desired action with the selected file
    let obj = { content: file.convertedContent, ext: "py" };
    setCurrOutputContent({ ...obj });

    //to change the code at first ide as well
    let obj2 = { content: file.content, ext: "js" };
    setCurrInputContent({ ...obj2 });

    //hide dropdown after selection
    setShowDropdown(!showDropdown);
  };

  return (
    <>
      <Navbar
        expand="lg"
        bg="light"
        variant="light"
        style={{ border: "solid #ccc" }}
      >
        <Navbar.Toggle aria-controls="action-buttons-navbar" />
        <Navbar.Collapse id="action-buttons-navbar">
          <Nav className="mr-auto">
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="convertio-tooltip">
                  Select multiple Files to convert
                </Tooltip>
              }
            >
              <span
                style={{
                  justifyContent: "align-item",
                  display: "flex",
                  marginLeft: "5%",
                }}
                onClick={handleSelectMulti}
              >
                <MdSelectAll className="mr-2" size={20} />
              </span>
            </OverlayTrigger>
            {/* for code explanation */}
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="convertio-tooltip">
                  Explain the selected file
                </Tooltip>
              }
            >
              <span
                style={{
                  justifyContent: "align-item",
                  display: "flex",
                  marginLeft: "20%",
                }}
                onClick={handleExplainClick}
              >
                <PiNotebookDuotone className="mr-2" size={20} />
              </span>
            </OverlayTrigger>
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="convertio-tooltip">Select the conversion</Tooltip>
              }
            >
              <span
                style={{
                  justifyContent: "align-item",
                  display: "flex",
                  marginLeft: "20%",
                }}
                onClick={handleLanguageClick}
              >
                <TbAB2 className="mr-2" size={20} />
              </span>
            </OverlayTrigger>

            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="convertio-tooltip">Convert your code</Tooltip>
              }
            >
              <span
                style={{
                  justifyContent: "align-item",
                  display: "flex",
                  marginLeft: "20%",
                }}
                onClick={handleConvertioClick}
              >
                <SiConvertio className="mr-2" size={20} />
              </span>
            </OverlayTrigger>
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="prompt-tooltip">
                  Give your own custom Prompt for conversion
                </Tooltip>
              }
            >
              <span
                style={{
                  justifyContent: "align-item",
                  display: "flex",
                  marginLeft: "20%",
                }}
                onClick={handlePromptClick}
              >
                <TbPrompt className="mr-2" size={20} />
              </span>
            </OverlayTrigger>
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="convertio-tooltip">Conversion Likeliness</Tooltip>
              }
            >
              <span
                style={{
                  justifyContent: "align-item",
                  display: "flex",
                  marginLeft: "20%",
                  color: conversionColor,
                }}
                //onClick={handleConversionLikeliness}
              >
                <BsFillRecordCircleFill className="mr-2" size={20} />
              </span>
            </OverlayTrigger>

            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="file-tooltip">
                  Review all the converted files
                </Tooltip>
              }
            >
              <span
                style={{
                  justifyContent: "align-item",
                  display: "flex",
                  marginLeft: "250%",
                }}
                onClick={handleCodeReview}
              >
                <GoCodeReview className="mr-2" size={20} />
              </span>
            </OverlayTrigger>
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="file-tooltip">
                  Add this as a cell in notebook
                </Tooltip>
              }
            >
              <span
                style={{
                  justifyContent: "align-item",
                  display: "flex",
                  marginLeft: "20%",
                }}
                onClick={handleAddCodeCell}
              >
                <AiOutlineAppstoreAdd className="mr-2" size={20} />
              </span>
            </OverlayTrigger>

            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="file-tooltip">Download the converted file</Tooltip>
              }
            >
              <span
                style={{
                  justifyContent: "align-item",
                  display: "flex",
                  marginLeft: "20%",
                }}
                onClick={handleFileDownloadClick}
              >
                <BsFileEarmarkArrowDownFill className="mr-2" size={20} />
              </span>
            </OverlayTrigger>
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="remote-repo-tooltip">
                  Push to your remote repo
                </Tooltip>
              }
            >
              <span
                style={{
                  justifyContent: "align-item",
                  display: "flex",
                  marginLeft: "20%",
                }}
                onClick={handleRemoteRepoClick}
              >
                <SiGithubactions className="mr-2" size={20} />
              </span>
            </OverlayTrigger>
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="remote-repo-tooltip">
                  Export it to Databricks workspace
                </Tooltip>
              }
            >
              <span
                style={{
                  justifyContent: "align-item",
                  display: "flex",
                  marginLeft: "20%",
                }}
                onClick={handleDatabricks}
              >
                <SiDatabricks className="mr-2" size={20} />
              </span>
            </OverlayTrigger>
            {/* Add more buttons with tooltips as needed */}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <Modal show={isLoading} backdrop="static" keyboard={false}>
        <Modal.Body>
          <div
            className="loading fixed"
            style={{ position: "relative", left: "10%" }}
          >
            <div
              style={{
                marginLeft: "30%",
                width: "10vw",
              }}
            >
              <Row>
                <Col>
                  {selectedFiles && (
                    <span>
                      <h2>
                        {filesCount}/{selectedFiles?.length}
                      </h2>
                    </span>
                  )}
                  {!selectedFiles && (
                    <span>
                      <h2>1/1</h2>
                    </span>
                  )}
                </Col>
                <Col>
                  <ScaleLoader color="#000000" loading={true} />
                </Col>
              </Row>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {showDropdown && (
        <Dropdown
          show={showDropdown}
          onClose={() => setShowDropdown(false)}
          style={{ position: "relative", left: "73.5%" }}
        >
          <Dropdown.Menu>
            {selectedFiles?.map((item, index) => (
              <Dropdown.Item
                key={index}
                onClick={() => handleDropdownSelect(item)}
                active={reviewSelected === item.name}
              >
                {item.name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      )}
      {showConversionDropdown && (
        <Dropdown
          show={showConversionDropdown}
          onClose={() => setShowConversionDropdown(false)}
          style={{ position: "relative", left: "11.5%" }}
        >
          <Dropdown.Menu>
            {possibleConversion?.map((item, index) => (
              <Dropdown.Item
                key={index}
                onClick={() => handleConversionDropdownSelect(item)}
                active={selectedConversion === item}
              >
                {item}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      )}
    </>
  );
};
